import React, { Component } from "react";
import { connect } from "react-redux";
import Helping from "../helpers/Helping";
import Service from "../helpers/service";
import { MESSAGE, NODE_ENV, ROLE, ROUTE_ACCESS } from '../config/index';
import { Link } from "react-router-dom";
import { API_URL } from '../config/urls';
import routes from '../config/routes';
import { trackPromise } from "react-promise-tracker";
import { fetchProfile, setProfileError } from '../actions/profile_action';
import { validateField, setErrorFields } from '../helpers/validationHelpers';
import Notification from "./layout/Notification";
import LoadingButton from "./fields/LoadingButton";

const { SENT, SYNC, MINT, SHUFFLE, EMPTY, REPLACE } = MESSAGE;
class Settings extends Component {
    constructor(props) {
        super(props);

        this.idsArray = [];
        this.state = {
            url: URL,
            first_code: "",
            second_code: "",
            buttonTitle: "submit",
            btnIsDisable: false
        };
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    componentDidMount() {
        this.setErrorOnApiCall();

        // this.props.fetchProfile();
    }

    handleChange = async ({ target: { name, value } }) => {
        this.setState({ [name]: value });
        if (name === "first_code") this.setState({ ...await validateField("string", name, value, "", 1) });
        if (name === "second_code") this.setState({ ...await validateField("string", name, value, "", 1) });
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    generateUserNotification = () => {
        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + routes.GET_FAN_CAVE_UPDATE,
                {}
            )
                .then(response => {
                    return this.setState({
                        error_message: Helping.getMessageString(SENT, "Email"),
                        error_type: 'success'
                    }, () => this.scrollToTop());
                })
                .catch(error => {
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsEnable: false
                        }, () => this.scrollToTop());
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "email")
                    }, () => this.scrollToTop());
                })
        )
    }

    syncAllLookups = () => {
        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + routes.GET_LOOKUP, { action: 'sync-all' })
                .then(response => {
                    return this.setState({
                        error_message: Helping.getMessageString(SYNC, "Lookups"),
                        error_type: 'success'
                    }, () => this.scrollToTop());
                })
                .catch(error => {
                    console.log({ error });
                    if (error.response) {
                        Helping.redirectToLogin(error);

                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsEnable: false
                        }, () => this.scrollToTop());
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "lookups")
                    }, () => this.scrollToTop());
                })
        )
    }

    shuffleItems = () => {
        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + routes.GET_SETTING, { action: 'shuffle-items' })
                .then(response => {
                    return this.setState({
                        error_message: Helping.getMessageString(SHUFFLE, "main items"),
                        error_type: 'success'
                    }, () => this.scrollToTop());
                })
                .catch(error => {
                    console.log({ error });
                    if (error.response) {
                        Helping.redirectToLogin(error);

                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsEnable: false
                        }, () => this.scrollToTop());
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "main items")
                    }, () => this.scrollToTop());
                })
        )
    }

    mintAutomatically = () => {
        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + routes.GET_SETTING, { action: 'mint-automate' })
                .then(response => {
                    return this.setState({
                        error_message: Helping.getMessageString(MINT, "main items minted"),
                        error_type: 'success'
                    }, () => this.scrollToTop());
                })
                .catch(error => {
                    console.log({ error });
                    if (error.response) {
                        Helping.redirectToLogin(error);

                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsEnable: false
                        }, () => this.scrollToTop());
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "minting main items")
                    }, () => this.scrollToTop());
                })
        )
    }

    closeReplaceModal = () => {
        window.$('#replaceMainItems').modal('hide');
        this.setState({
            first_code: '',
            second_code: '',
            error_first_code_message: '',
            error_second_code_message: ''
        });
    }

    checkEmptyReplaceFields = () => {
        const { first_code, second_code } = this.state;
        let formHasError = false;

        if (first_code.length < 1) {
            let errorObject = setErrorFields("first_code", Helping.getMessageString(EMPTY, "first_code"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (second_code.length < 1) {
            let errorObject = setErrorFields("second_code", Helping.getMessageString(EMPTY, "second_code"));
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    submitReplaceModal = (e) => {
        e.preventDefault();

        const { first_code, second_code } = this.state,
            formHasError = false;
        if (formHasError) {
            window.scrollToErrorFields();
            return true;
        }

        this.setState({
            btnIsDisable: true
        })

        Service.postCall(API_URL.ADMIN_TRADING_API + routes.GET_SETTING, {
            action: 'nfts-replacement',
            codes: [first_code, second_code]
        })
            .then(response => {
                this.setState({
                    error_message: Helping.getMessageString(REPLACE, "main items"),
                    error_type: "success",
                    btnIsDisable: false
                }, () => { this.closeReplaceModal(); this.scrollToTop(); });
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return this.setState({
                        error_message: error.response.data.message.message,
                        error_type: 'danger',
                        btnIsDisable: false
                    }, () => { this.closeReplaceModal(); this.scrollToTop(); });
                }
                return this.setState({
                    isLoading: false,
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, "replacing avatar")
                }, () => { this.closeReplaceModal(); this.scrollToTop(); });
            });
    }

    sendCardanoItem = () => {
        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + 'assign-nft')
                .then(response => {
                    return this.setState({
                        error_message: response.data.message,
                        error_type: 'success'
                    }, () => this.scrollToTop());
                })
                .catch(error => {
                    if (error.response) {
                        Helping.redirectToLogin(error);

                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                        }, () => this.scrollToTop());
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "sending cardano item")
                    }, () => this.scrollToTop());
                })
        )
    }

    syncAlgolia = () => {
        trackPromise(
            Service.getCall(API_URL.ITEM_URL + 'upload-items-algolia')
                .then(response => {
                    return this.setState({
                        error_message: Helping.getMessageString(SYNC, 'Algolia'),
                        error_type: 'success'
                    }, () => this.scrollToTop());
                })
                .catch(error => {
                    if (error.response) {
                        Helping.redirectToLogin(error);

                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                        }, () => this.scrollToTop());
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "sync algolia")
                    }, () => this.scrollToTop());
                })
        )
    }

    render() {
        let role_access = {}, isAdmin = false;
        if (Object.keys(this.props.profile).length > 0) {
            role_access = this.props.profile.role_access.length > 1 ? JSON.parse(this.props.profile.role_access) : {};
            isAdmin = role_access.role === ROLE.ADMIN.toLowerCase();
        }
        return (
            <>
                <div class="content create-json setting-page">
                    <div class="top-header">
                        <div class="header-title">
                            <h2 class="title">Settings</h2>
                            <span class="title-caption">You can change settings here.</span>
                        </div>
                        <div class="header-btn">
                            <Link to="/dashboard" class="custom-btn dark-btn icon-btn sm-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12.117" viewBox="0 0 15.5 12.117">
                                    <g id="Arrow_-_Left" data-name="Arrow - Left" transform="translate(0.75 1.059)">
                                        <g id="Arrow_-_Left-2" data-name="Arrow - Left" transform="translate(14) rotate(90)">
                                            <path id="Stroke_1" data-name="Stroke 1" d="M0,14V0" transform="translate(5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                            <path id="Stroke_3" data-name="Stroke 3" d="M10,0,5,5.647,0,0" transform="translate(0 8.353)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                        </g>
                                    </g>
                                </svg>
                                <span class="txt-btn">Back</span>
                            </Link>
                        </div>
                    </div>
                    <div class="main-content">
                        {this.state.error_message &&
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                                callback={this.removeNetworkError}
                            />
                        }
                        <div class="setting">
                            <h4 class="">Sync all Lookups</h4>
                            <button type="submit"
                                class="custom-btn sm-btn gradiant-btn"
                                disabled={!(isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.SYNCLOOKUPS.toLowerCase()].write))}
                                onClick={this.syncAllLookups}>
                                Sync all Lookups
                            </button>
                        </div>
                        <div class="setting">
                            <h4 class="">Shuffle Main Items</h4>
                            <button type="submit"
                                class="custom-btn sm-btn gradiant-btn"
                                disabled={!(isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.SHUFFLENFTS.toLowerCase()].write))}
                                onClick={this.shuffleItems}>
                                Shuffle Main Items
                            </button>
                        </div>
                        <div class="setting">
                            <h4 class="">Replace Main Items</h4>
                            <button type="submit"
                                class="custom-btn sm-btn gradiant-btn"
                                data-toggle="modal" data-target="#replaceMainItems"
                                disabled={!(isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.REPLACENFTS.toLowerCase()].write))}
                            >
                                Replace Main Items
                            </button>
                        </div>
                        <div class="setting">
                            <h4 class="">Send Cardano Gift Item</h4>
                            <button type="submit"
                                class="custom-btn sm-btn gradiant-btn"
                                disabled={!(isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.SENDCARDANO.toLowerCase()].write))}
                                onClick={this.sendCardanoItem}
                            >
                                Send Cardano Gift Item
                            </button>
                        </div>
                        <div class="setting">
                            <h4 class="">Sync Algolia</h4>
                            <button type="submit"
                                class="custom-btn sm-btn gradiant-btn"
                                disabled={!(isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.SYNCALGOLIA.toLowerCase()].write))}
                                onClick={this.syncAlgolia}
                            >
                                Sync Algolia
                            </button>
                        </div>
                        <div class="setting">
                            <h4 class="">Mint Automatically</h4>
                            <button type="submit"
                                class="custom-btn sm-btn gradiant-btn"
                                disabled={NODE_ENV.toLowerCase() === 'production' || !(isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.MINTAUTOMATICALLY.toLowerCase()].write))}
                                onClick={this.mintAutomatically}>
                                Mint Automatically
                            </button>
                        </div>
                    </div>
                </div>

                {/* --- Replace Items Modal --- */}
                <div class="actionModal modal fade" id="replaceMainItems" tabindex="-1" role="dialog" aria-labelledby="replaceMainItems" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">Replace Main Items</h5>
                            </div>

                            <div class="modal-body">
                                <div class="form-group">
                                    <label for="firstcode">First code: </label>
                                    <input type="text" class={`form-control ${this.state.error_first_code_message ? 'error-input' : ''}`} name="first_code" id="firstcode" value={this.state.first_code} onChange={(e) => this.handleChange(e)} />
                                    <span className="error-msg">{this.state.error_first_code_message}</span>
                                </div>
                                <div class="form-group mb-0">
                                    <label for="secondCode">Second code: </label>
                                    <input type="text" class={`form-control ${this.state.error_second_code_message ? 'error-input' : ''}`} name="second_code" id="secondCode" value={this.state.second_code} onChange={(e) => this.handleChange(e)} />
                                    <span className="error-msg">{this.state.error_second_code_message}</span>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                                {this.state.btnIsDisable ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.submitReplaceModal(e)}>{this.state.btnIsDisable ? 'Loading...' : 'Submit'}</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = {
    fetchProfile
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)